module.exports = __webpack_public_path__ + "img/9791195349821.a063567e.jpg";